<template lang="pug">
div
	v-alert.my-6(v-if="!$store.state.user.id" type="info" color="accent" text border="bottom")
		i18n(path="reply-form:read.forum.login.to.post.explainer")
			login-action.d-inline( slot="login")
				template(#activator="{on}")
					nuxt-link(v-on:click.native="on.click" :to="localePath({ name: 'login' })") {{$t('reply-form:forum.login')}}
			nuxt-link( :to="localePath({ name: 'register' })" slot="account") {{$t('reply-form:forum.account')}}
	validation-observer(v-slot="{ handleSubmit }" ref="form" v-else)
		v-form(ref="reply-form" @submit.prevent="handleSubmit(submitReply)")
			v-alert.my-6(type="info" color="accent" text dense v-if="showForumRules")
				i18n(path="reply-form:read.forum.rules.explainer")
					a(:href="localePath({ name: 'forum-rules'})" target="_blank" slot="link") {{$t('reply-form:forum.rules')}}
			validation-provider(v-slot="{errors}" rules="wscontent" name="content" slim :customMessages="{wscontent: $t('reply-form:reply.error.required')}")
				v-input(:error-messages="errors" hide-details="auto")
					forum-content-editor.mb-6(v-model="content" type="textarea" editorRef="replyform" ref="forumcontent" :disabled="isPosting" v-on:is-uploading="(value)=>isUploading=value")
			v-checkbox.mt-0(v-if="showSubmitButton && !hideNotify" v-model="notifyMe" on-icon="favorite" off-icon="favorite_border" color="#ff5a5e"  :label="$t('reply-form:subscribe.to.topic')"  :disabled="isPosting")
			v-btn(v-if="showSubmitButton" type="submit" color="primary" outlined :disabled="isPosting || isUploading") {{$t('reply-form:submit.reply')}}
</template>

<script>
import gql from 'graphql-tag';

import ForumContentEditor from '@/components/forum/forum-content-editor';
import UserContentDetails from '@/components/user-content/fragments.js';

export default {
	name: 'ReplyForm',
	components: { ForumContentEditor },
	props: {
		value: {
			type: String,
			default: null
		},
		parentId: {
			type: String,
			required: true
		},
		parentType: {
			type: String,
			required: true
		},
		isposting: {
			type: Boolean,
			default: false
		},
		compact: {
			type: Boolean,
			default: false
		},
		hideNotify: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			showForumRules: true,
			showSubmitButton: true,
			notifyMe: false,
			isPosting: false,
			isUploading: false,
			content: { markdown: '', media: {} }
		};
	},
	watch: {
		value() {
			if (this.value) {
				this.content.markdown += this.value;
				this.$emit('input', null);
			}
		}
	},
	created() {
		this.isPosting = this.isposting;
		if (this.compact) {
			this.showForumRules = false;
			this.showSubmitButton = false;
			this.unwatchIsCompact = this.$watch('content', () => {
				this.showSubmitButton = true;
				this.showForumRules = true;
				this.unwatchIsCompact();
			});
		}
	},
	methods: {
		submitReply() {
			if (this.$store.state.user.id) {
				this.isPosting = true;
				this.$emit('update:isposting', true);

				const replyContent = this.$lodash.cloneDeep(this.content);

				const reply = {
					parent: { id: this.parentId, type: this.parentType },
					content: replyContent,
					notifyMe: this.notifyMe
				};

				return this.$graphClient
					.mutate({
						mutation: gql`
							mutation ($reply: ReplyInput) {
								saveReply(reply: $reply) {
									...UserContentDetails
								}
							}
							${UserContentDetails}
						`,
						errorPolicy: 'all',
						variables: {
							reply
						}
					})

					.then(({ data, errors }) => {
						if (errors) {
							if (errors[0].message.includes('spamError:')) {
								this.$toast.error(this.$t('reply-form:spam.error'));
							} else {
								throw errors[0];
							}
						}

						if (data.saveReply) {
							data.saveReply.newPost = true;

							this.$emit('submit-reply', data.saveReply);
							this.content = { markdown: '', media: {} };
						}
						this.$refs.form.reset();

						return data.saveReply;
					})
					.catch(_error => {
						this.$toast.error(this.$t('reply-form:submit.error'));
					})
					.finally(() => {
						this.isPosting = false;
						this.$emit('update:isposting', false);

						this.content.markdown = '';

						// const cm = this.$refs.forumcontent.$refs.replyform.simplemde
						// 	.codemirror;
						// cm.setValue('');
						// cm.clearHistory();
					});
			} else {
				this.$toast.error(this.$t('reply-form:error.user.not.loggedin'));
			}
		}
	}
};
</script>
